/**
 * Whether a vaccine the destination guidance names is already on the
 * traveller's record. Guidance and records share no code system, so this
 * compares names: "Hepatitis A" matches a record named "Hepatitis A (Havrix)".
 *
 * Deliberately conservative — a vaccine is only ticked off when one name
 * contains the other, never on a partial word, since ticking a vaccine the
 * traveller does not have is worse than leaving one for them to tick.
 */
function normalise(name: string): string {
  return ` ${name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim()} `;
}

export function isVaccineRecorded(
  guidanceName: string,
  recordedNames: readonly string[],
): boolean {
  const wanted = normalise(guidanceName);
  if (wanted.trim().length < 3) return false;
  return recordedNames.some((recorded) => {
    const have = normalise(recorded);
    return have.includes(wanted) || wanted.includes(have);
  });
}
